/**
 * Created by neo on 21.01.26
 */
import { ExploreWeaviateSearchResult, createExploreWeaviateSearchResult } from './ExploreWeaviateSearchResult';
import { HttpBackend } from '../../Services/Http/HttpBackend';
import { Pageable } from '../Interfaces/Pageable';

export type ExploreWeaviateSearchParams = Pageable & {
  concepts: string[];
  autocut: number;
  filter?: string[];
};

let abortController: AbortController | null = null;

export const ExploreWeaviateSearchApi = {
  search(request: Partial<ExploreWeaviateSearchParams>): Promise<ExploreWeaviateSearchResult> {
    if (abortController) {
      abortController.abort();
    }
    abortController = new AbortController();

    return HttpBackend.get(`/coach-program/weaviate`, request, {
      signal: abortController.signal,
    })
      .then((res) => createExploreWeaviateSearchResult(res))
      .finally(() => {
        abortController = null;
      });
  },

  abort(): void {
    if (abortController) {
      abortController.abort();
      abortController = null;
    }
  },
};

export const ExploreWeaviateSearch = ExploreWeaviateSearchApi;
